import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../../_metronic/layout/core';
import ExpenseByCategory from '../ExpenseByCategory';
import ExpenseDetail from '../ExpenseDetail';
import ExpenseSummary from '../ExpenseSummary';
import ExpenseViolationReport from '../ExpenseViolationReport';
import TeamReportTabs from './TeamReportTabs';
import { Alert } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import CategoryBudgetReport from '../CategoryBudgetReport';
import { allRoutes } from '../../../routing/All_Routes';


const teamReportBreadCrumbs: Array<PageLink> = [
    {
        title: 'Analytics',
        path: `${allRoutes.analytics}/team-report/expense-summary`,
        isSeparator: false,
        isActive: true,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
    {
        title: 'Team Reports',
        path: `${allRoutes.analytics}/team-report/expense-summary`,
        isSeparator: false,
        isActive: true,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    }, {
        title: '',
        path: '',
        isSeparator: false,
        isActive: false,
    },
]

const TeamReportPage = () => {
    const [show, setShow] = useState(true);

    useEffect(() => {
        if (!show) return;
        const timer = setTimeout(() => {
            setShow(false);
        }, 5000);
        return () => clearTimeout(timer);
    }, [show]);

    return (
        <div className='ss-analytics-report-wrapper'>
            <Routes>
                <Route
                    element={
                        <>
                            {show &&
                                <Alert variant="primary" onClose={() => setShow(false)} dismissible className="mb-2 py-2 d-flex align-items-center">
                                    <p className='mb-0 fs-7'>By default, data is displayed from the last 7 days.</p>
                                </Alert>}
                            <TeamReportTabs />
                            <Outlet />
                        </>
                    }
                >
                    <Route
                        path='expense-summary'
                        element={
                            <>
                                <PageTitle breadcrumbs={teamReportBreadCrumbs}>Expense Summary</PageTitle>
                                <ExpenseSummary />
                            </>
                        }
                    />
                    <Route
                        path='expense-detail'
                        element={
                            <>
                                <PageTitle breadcrumbs={teamReportBreadCrumbs}>Expense Details</PageTitle>
                                <ExpenseDetail />
                            </>
                        }
                    />
                    <Route
                        path='expense-by-category'
                        element={
                            <>
                                <PageTitle breadcrumbs={teamReportBreadCrumbs}>Expense Categories</PageTitle>
                                <ExpenseByCategory />
                            </>
                        }
                    />
                    <Route
                        path='expense-violations'
                        element={
                            <>
                                <PageTitle breadcrumbs={teamReportBreadCrumbs}>Expense Violations</PageTitle>
                                <ExpenseViolationReport />
                            </>
                        }
                    />
                    <Route
                        path='category-budget'
                        element={
                            <>
                                <PageTitle breadcrumbs={teamReportBreadCrumbs}>Category Budget</PageTitle>
                                <CategoryBudgetReport />
                            </>
                        }
                    />
                    <Route index element={<Navigate to={`${allRoutes.analytics}/team-report/expense-summary`} />} />
                </Route>
            </Routes>
        </div>
    );
};

export default TeamReportPage;
